<template>
  <div>
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->

      <div v-if="english" key="english">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Dashboard <span class="lastname lastnameNoBorder">Capsule</span>
              </h1>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/qLJ2ZIpb3uc"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>
              <p>
                The main project I worked on during my apprenticeship at the
                Rectorat de Versailles was the creation of a dashboard
                communicating with their back-end. The team that worked on the
                back-end was mainly system administrators, who learned Python
                for the occasion. For the front-end, they decided to let a
                student on a apprenticeship work alone. That's where I come in.
              </p>
              <p>
                After choosing the Angular framework and the
                <a
                  href="https://www.akveo.com/ngx-admin/pages/dashboard"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                >
                  ngx-admin
                </a>
                theme, I started coding the interface and about 6 months later,
                I was able to satisfy them with this result.
              </p>

              <h4>Capsule creation</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/s_XejF-gLTI"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>

              <h4>Capsule Settings</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/UwPgwR71Acg"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>

              <h4>Webapp settings</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/c2-Wg2Io99g"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>

              <h4>Crons settings</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/_m--qCmSH5E"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>
            </div>
          </section>
        </div>
      </div>
      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" key="french">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Dashboard <span class="lastname lastnameNoBorder">Capsule</span>
              </h1>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/qLJ2ZIpb3uc"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>
              <p>
                Le projet principal sur lequel j'ai travaillé pendant mon
                alternance au rectorat de Versailles était la création d'un
                dashboard communiquant avec leur back-end. L'équipe qui bossait
                sur le back-end était principalement des administrateurs
                système, qui ont appris le Python pour l'occasion. Pour la
                partie front, ils ont décidé de faire appel à un alternant
                uniquement. C'est là que j'entre en scène.
              </p>
              <p>
                Après avoir choisi le framework Angular et le thème
                <a href="https://www.akveo.com/ngx-admin/pages/dashboard"
                  >ngx-admin</a
                >, j'ai commencé à coder l'interface et environ 6 mois plus
                tard, j'ai pu les satisfaire avec ce résultat.
              </p>

              <h4>Création de capsules</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/s_XejF-gLTI"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>

              <h4>Paramétrage de capsules</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/UwPgwR71Acg"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>

              <h4>Paramétrage de webapp</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/c2-Wg2Io99g"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>

              <h4>Paramétrage de crons</h4>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/_m--qCmSH5E"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>
            </div>
          </section>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    larger: Boolean,
    english: Boolean,
    isMobile: Boolean,
  },
};
</script>